import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBXnhkMUf_gkXikrvSuu3eDyzrJ4IfBykc",
  authDomain: "qss-dashboard-6f242.firebaseapp.com",
  projectId: "qss-dashboard-6f242",
  storageBucket: "qss-dashboard-6f242.firebasestorage.app",
  messagingSenderId: "696244839128",
  appId: "1:696244839128:web:1a2ee621c2bb7cef80edad",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
